export const TOP_MENU_ROUTE = '/top-menu/';
export const SALAD_ROUTE = TOP_MENU_ROUTE + 'salad/';
export const STIRFRY_ROUTE = TOP_MENU_ROUTE + 'stirfry/';
export const HONEYBAR_ROUTE = TOP_MENU_ROUTE + 'honeybar/';
export const FEATURED_ROUTE = TOP_MENU_ROUTE + 'featured/';
